/* Alerte « retour en stock » native du thème (cf. snippets/awp-back-in-stock.liquid).
   Aucun script tiers : l'inscription part au clic, par l'API client de Klaviyo. */
(() => {
  if (window.awpBackInStock) return;
  window.awpBackInStock = true;

  const ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  const REVISION = '2026-07-15';

  /* Ouverture : délégation, car <buy-buttons> (qui contient le bouton) est re-rendu par le thème
     à chaque changement de variante. */
  document.addEventListener('click', event => {
    const opener = event.target.closest('.awp-bis-open');
    if (!opener) return;
    const dialog = document.getElementById(opener.getAttribute('aria-controls'));
    if (!dialog) return;
    event.preventDefault();
    const form = dialog.querySelector('.awp-bis-dialog__form');
    form.elements.variants.value = opener.closest('[data-awp-bis-variants]')?.dataset.awpBisVariants || '';
    dialog.querySelector('.awp-bis-dialog__status').textContent = '';
    dialog.showModal();
    form.elements.email.focus();
  });

  /* Clic sur le fond : fermeture. */
  document.addEventListener('click', event => {
    if (event.target.classList?.contains('awp-bis-dialog')) event.target.close();
  });

  const subscribe = (company, email, variantId) => fetch(`${ENDPOINT}?company_id=${encodeURIComponent(company)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
    body: JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } }
        }
      }
    })
  }).then(response => {
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response;
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('.awp-bis-dialog__form');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;

    const dialog = form.closest('dialog');
    const status = dialog.querySelector('.awp-bis-dialog__status');
    const button = form.querySelector('[type="submit"]');
    const email = form.elements.email.value.trim();
    const variants = form.elements.variants.value.split(',').filter(Boolean);
    if (!variants.length) return;

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    status.textContent = '';

    /* Taille indicative : une inscription par variante, la montre entière est suivie. */
    const results = await Promise.allSettled(variants.map(id => subscribe(dialog.dataset.company, email, id)));
    const ok = results.some(r => r.status === 'fulfilled');
    status.textContent = ok ? dialog.dataset.ok : dialog.dataset.error;
    if (ok) form.elements.email.value = '';
    else console.warn('[awp-back-in-stock]', results.map(r => r.reason?.message));

    button.removeAttribute('aria-busy');
    button.disabled = false;
  });
})();
